import { isRef, watch, unref, onMounted, onBeforeUnmount } from 'vue';

export const useEventListener = (target: EventTarget, event: string, handler: EventListenerOrEventListenerObject) => {
  if (isRef(target)) {
    watch(target, (value, oldValue: any) => {
      oldValue?.removeEventListener(event, handler);
      value?.addEventListener(event, handler);
    });
  } else {
    onMounted(() => {
      target.addEventListener(event, handler);
    });
  }

  onBeforeUnmount(() => {
    unref(target)?.removeEventListener(event, handler);
  });
};
